import { render, staticRenderFns } from "./ChangDaokaDataLight.vue?vue&type=template&id=39d8cbfe&scoped=true"
import script from "./ChangDaokaDataLight.vue?vue&type=script&lang=js"
export * from "./ChangDaokaDataLight.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39d8cbfe",
  null
  
)

export default component.exports